// Site-wide constants, deliberately in a plain module with no React (and no
// react-helmet-async) in its import graph. src/lib/wordpress.ts needs SITE_URL
// to build its REST API base, and App.tsx imports wordpress.ts eagerly for
// getStaticPaths at build time — so sourcing this from a component module
// (Seo.tsx) dragged the whole Helmet dependency into that eager graph for no
// reason.
export const SITE_URL = "https://p2amarketing.com.br";

export const DEFAULT_IMAGE = `${SITE_URL}/wp-content/uploads/2026/03/Logo-branca-Sem-fundo.png`;

// Contact/NAP constants — the same phone number used site-wide for WhatsApp
// links, reused here for the schema's `telephone` and the footer's visible
// tel: link (single source, so they can't drift out of sync).
export const PHONE_E164 = "+5524993144981";
export const PHONE_DISPLAY = "(24) 99314-4981";

// City/state only, not a full street address: P2A serves clients nationwide,
// not walk-in traffic at a physical location — Resende/RJ is disclosed for
// local-SEO signals, deliberately without a streetAddress field.
export const ADDRESS_LOCALITY = "Resende";
export const ADDRESS_REGION = "RJ";
